export const Logo = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" data-testid="brand-logo">
    <defs>
      <linearGradient id="bmpGold" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#F5DFA8" />
        <stop offset="0.55" stopColor="#E9C88A" />
        <stop offset="1" stopColor="#C99A4E" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="15" fill="#0A0D14" />
    <rect x="1.25" y="1.25" width="61.5" height="61.5" rx="13.75" stroke="url(#bmpGold)" strokeOpacity="0.45" strokeWidth="1.5" />
    <text x="13" y="46" fontFamily="Fraunces, Georgia, serif" fontSize="35" fontWeight="600" fill="url(#bmpGold)">B</text>
    <text x="36.5" y="45" fontFamily="Fraunces, Georgia, serif" fontSize="14" fontWeight="600" letterSpacing="1.5" fill="url(#bmpGold)">MP</text>
    <path d="M51 8.5 L55.5 13 L51 17.5 L46.5 13 Z" fill="#38BDF8" />
  </svg>
);

export default Logo;
